// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"WheelTyreFilter_resetButton__iMqJE"};